import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Package, ClipboardList } from 'lucide-react';
import OrderCard from '../components/OrderCard';
import LoadingSpinner from '../components/LoadingSpinner';
import { ListSkeleton } from '../components/Skeleton';
import { useOrders } from '../hooks/useOrders';

const TABS = [
  { id: 'todos', label: 'Todos' },
  { id: 'pendiente', label: 'Pendientes' },
  { id: 'confirmado', label: 'Confirmados' },
  { id: 'entregado', label: 'Entregados' },
];

const MyOrders = () => {
  const { orders, loading, fetchOrders } = useOrders();
  const [activeTab, setActiveTab] = useState('todos');

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  const filteredOrders = orders.filter(order => {
    if (activeTab === 'todos') return true;
    return order.status === activeTab;
  });

  // Sort by date (newest first)
  const sortedOrders = [...filteredOrders].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  return (
    <div className="min-h-screen bg-background pt-20 pb-24 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-display font-bold text-[#1B263B] mb-2">
            Mis Pedidos
          </h1>
          <p className="text-[#7A756F]">
            Revisa el estado de tus pedidos
          </p>
        </div>

        {/* Tabs */}
        <div className="flex gap-2 overflow-x-auto pb-2 mb-6 scrollbar-hide">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                activeTab === tab.id
                  ? 'bg-primary text-white'
                  : 'bg-white text-[#7A756F] border border-[#EFEDEA] hover:border-primary'
              }`}
            >
              {tab.label}
              {tab.id !== 'todos' && (
                <span className="ml-1.5 px-1.5 py-0.5 text-xs rounded-full bg-current bg-opacity-20">
                  {orders.filter(o => o.status === tab.id).length}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Orders List */}
        {loading ? (
          <ListSkeleton count={3} />
        ) : sortedOrders.length > 0 ? (
          <div className="space-y-4">
            {sortedOrders.map((order, index) => (
              <Link 
                key={order.id} 
                to={`/pedidos/${order.code}`}
                className="block animate-fadeInUp"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <OrderCard order={order} />
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-[#F8F7F5] flex items-center justify-center">
              <ClipboardList size={32} className="text-[#BCB8B1]" />
            </div>
            <h3 className="font-display font-bold text-xl text-[#1B263B] mb-2">
              No hay pedidos
            </h3>
            <p className="text-[#7A756F] mb-6">
              {activeTab === 'todos'
                ? 'Aún no has realizado ningún pedido'
                : `No tienes pedidos ${activeTab === 'pendiente' ? 'pendientes' : activeTab + 's'}`
              }
            </p>
            <Link to="/productos">
              <button className="px-6 py-3 bg-primary text-white font-semibold rounded-xl hover:bg-primary-hover transition-colors">
                Ver productos
              </button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyOrders;
